/*
 * @Date: 2024-03-18 13:48:50
 * @Author: hzq
 * @LastEditTime: 2024-04-01 16:46:21
 * @Descripttion: 
 */
/***
 * 创建人：李珊
 * 时间：2021-01-18
 * 描述：查看实体详情弹框
 * 更新说明:
 */
import { Component, OnInit, Output, EventEmitter, ViewChild, Input } from '@angular/core';
import { SwMassageBoxService } from 'src/app/librarys/serves/sw-massage-box.service';
import { KmsService } from 'src/app/areas/kms/kms.service';
import { SwModalframeComponent } from 'src/app/librarys/components/basic-components/sw-modal-frame/sw-modal-frame.component';
@Component({
  selector: 'app-instance-info-view',
  templateUrl: './instance-info-view.component.html',
  styleUrls: ['./instance-info-view.component.css']
})
export class InstanceInfoViewComponent implements OnInit {
  
  @ViewChild('modal') modal: SwModalframeComponent;    //弹出层组件
  @Input() param:any;
  @Output() callback = new EventEmitter(); //抛出事件
  // 实体id
  instanceId:string = ''
  constructor(
    private box: SwMassageBoxService,  //消息提示框
    private service: KmsService,   //请求服务
  ) { 

  }

  ngOnInit() {
    this.instanceId = this.param['instanceId'];
    console.log('this.instanceId',this.instanceId)

  }
}

